import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationAL from './locales/al/translation.json';
import translationMK from './locales/mk/translation.json';
import translationEN from './locales/en/translation.json';
import translationTR from './locales/tr/translation.json';
import translationHR from './locales/hr/translation.json';
import translationSR from './locales/sr/translation.json';
import translationDE from './locales/de/translation.json';

const resources = {
  al: {
    translation: translationAL,
  },
  mk: {
    translation: translationMK,
  },
  en: {
    translation: translationEN,
  },
  tr: {
    translation: translationTR,
  },
  hr: {
    translation: translationHR,
  },
  sr: {
    translation: translationSR,
  },
  de: {
    translation: translationDE,
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'mk', // Set default language to Macedonian
    fallbackLng: 'mk',
    supportedLngs: ['mk', 'al', 'en', 'tr', 'hr', 'sr', 'de'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: [],
      caches: false,
    },
  });

export default i18n; 